import { useState, useEffect } from 'react';

/**
 * useMousePosition - Tracks mouse position for parallax effects
 *
 * @returns {{x: number, y: number}} Mouse position coordinates
 *
 * @example
 * const mousePosition = useMousePosition();
 * // Use mousePosition.x and mousePosition.y for parallax transformations
 */
export function useMousePosition() {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return mousePosition;
}

export default useMousePosition;
